import styled from 'styled-components'
import FormInput from 'components/UI/FormInput/FormInput'
import { fontSize, Title } from '../../../../DashboardSettings.styles'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'

export const Wrapper = styled.div`
  width: 280px;
  margin-right: 40px;

  @media (max-width: 950px) {
    width: unset;
  }
`

export const StyledTitle = styled(Title)`
  display: inline-block;
`

export const StyledFormInput = styled(FormInput)`
  margin-right: 10px;
`

export const UpgradePromo = styled.div`
  margin-top: 25px;
`

export const UpgradeMessage = styled.p`
  color: ${colors.orange};
  font-size: ${fontSize.small};
  margin-top: 0px;
  margin-bottom: 10px;
`
